import Dashboard from './Dashboard';
import * as Interviews from './Interviews';
import * as Journeys from './Journeys';
import * as Participants from './Participants';
import Report from './Report';

export { Dashboard, Interviews, Journeys, Participants, Report };



// WEBPACK FOOTER //
// ./src/pages/Admin/index.js